import { createApp } from 'vue';
import D1D9 from '../../../career/D1D9.vue'

const appElements = document.querySelectorAll('.vue-render-d1d9')

Array.from(appElements).forEach(element => {
  createApp(D1D9).mount(element);
});